module.exports = __webpack_public_path__ + "img/porte-interieure.8c6c6f5.svg";